export const ポケモン = [
  'フシギダネ',
  'フシギソウ',
  'フシギバナ',
  'ヒトカゲ',
  'リザード',
  'リザードン',
  'ゼニガメ',
  'カメール',
  'カメックス',
  'キャタピー',
  'トランセル',
  'バタフリー',
  'ビードル',
  'コクーン',
  'スピアー',
  'ポッポ',
  'ピジョン',
  'ピジョット',
  'コラッタ',
  'ラッタ',
  'オニスズメ',
  'オニドリル',
  'アーボ',
  'アーボック',
  'ピカチュウ',
  'ライチュウ',
  'サンド',
  'サンドパン',
  'ニドラン',
  'ニドリーナ',
  'ニドクイン',
  'ニドリーノ',
  'ニドキング',
  'ピッピ',
  'ピクシー',
  'ロコン',
  'キュウコン',
  'プリン',
  'プクリン',
  'ズバット',
  'ゴルバット',
  'ナゾノクサ',
  'クサイハナ',
  'ラフレシア',
  'パラス',
  'パラセクト',
  'コンパン',
  'モルフォン',
  'ディグダ',
  'ダグトリオ',
  'ニャース',
  'ペルシアン',
  'コダック',
  'ゴルダック',
  'マンキー',
  'オコリザル',
  'ガーディ',
  'ウインディ',
  'ニョロモ',
  'ニョロゾ',
  'ニョロボン',
  'ケーシィ',
  'ユンゲラー',
  'フーディン',
  'ワンリキー',
  'ゴーリキー',
  'カイリキー',
  'マダツボミ',
  'イツィドン',
  'ウツボット',
  'メノクラゲ',
  'トククラゲ',
  'イシツブテ',
  'ゴローン',
  'ゴローニャ',
  'ポニータ',
  'ギャロップ',
  'ヤドン',
  'ヤドラン',
  'コイル',
  'レアコイル',
  'カモネギ',
  'ドードー',
  'ドードリオ',
  'パウワウ',
  'ジュゴン',
  'ベトベター',
  'ベトベトン',
  'シェルダー',
  'パルシェン',
  'ゴース',
  'ゴースト',
  'ゲンガー',
  'イワーク',
  'スリープ',
  'スリーパー',
  'クラブ',
  'キングラー',
  'ビリリダマ',
  'マルマイン',
  'タマタマ',
  'ナッシー',
  'カラカラ',
  'ガラガラ',
  'サワムラー',
  'エビワラー',
  'ペロリンガ',
  'トガース',
  'マタドガス',
  'サイホーン',
  'サイドン',
  'ラッキー',
  'モンジャラ',
  'ガルーラ',
  'タッツー',
  'シートラ',
  'トサキント',
  'アズマオウ',
  'ヒトデマン',
  'スターミー',
  'バリヤード',
  'ストライク',
  'ルージュラ',
  'エレブー',
  'ブーバー',
  'カイロス',
  'ケンタロス',
  'コイキング',
  'ギャラドス',
  'ラプラス',
  'メタモン',
  'イービイ',
  'シャワーズ',
  'サンダース',
  'ブースター',
  'ポリゴン',
  'オムナイト',
  'オムスター',
  'カブト',
  'カブトプス',
  'プテラ',
  'カビゴン',
  'フリーザ',
  'サンダー',
  'ファイヤー',
  'ミニリュウ',
  'ハクリュー',
  'カイリュー',
  'ミュウツー',
  'ミュウ',
  'チコリータ',
  'ベイリーフ',
  'メガニウム',
  'ヒノアラシ',
  'マグマラシ',
  'バクフーン',
  'ワニノコ',
  'アリゲイツ',
  'オーダイル',
  'オタチ',
  'オオタチ',
  'ホーホー',
  'ヨルノズク',
  'レディバ',
  'レディアン',
  'イトマル',
  'アリアドス',
  'クロバット',
  'チョンチー',
  'ランターン',
  'ピチュー',
  'ピィ',
  'ププリン',
  'トゲビー',
  'トゲチック',
  'ネイティ',
  'ネイティオ',
  'メリープ',
  'モココ',
  'デンリュウ',
  'キレイハナ',
  'マリル',
  'マリルリ',
  'ウソッキー',
  'ニョロトノ',
  'ハネッコ',
  'ポポッコ',
  'ワタッコ',
  'エイパム',
  'ヒマナッツ',
  'キマワリ',
  'ヤンヤンマ',
  'ウパー',
  'ヌオー',
  'エーフィ',
  'ブラッキー',
  'ヤミカラス',
  'ヤドキング',
  'ムウマ',
  'アンノーン',
  'ソーナンス',
  'キリンリキ',
  'クヌギダマ',
  'フォレトス',
  'ノコッチ',
  'グライガー',
  'ハゲネール',
  'ブルー',
  'グランブル',
  'ハリーセン',
  'ハッサム',
  'ツボツボ',
  'ヘラクロス',
  'ニューラ',
  'ヒメグマ',
  'リングマ',
  'マグマッグ',
  'マグカルゴ',
  'ウリムー',
  'イノムー',
  'サニーゴ',
  'テッポウオ',
  'オクタン',
  'デリバード',
  'マンタイン',
  'エアームド',
  'デルビル',
  'ヘルガー',
  'キングドラ',
  'ゴマゾウ',
  'ドンファン',
  'オドシシ',
  'ドーブル',
  'バルキー',
  'カポエラー',
  'ムチューリ',
  'エレキッド',
  'ブビィ',
  'ミルタンク',
  'ハピナス',
  'ライコウ',
  'エンテイ',
  'スイクン',
  'ヨーギラス',
  'サナギラス',
  'バンギラス',
  'ルギア',
  'ホウオウ',
  'セレビィ',
  'キモリ',
  'ジュプトル',
  'ジュカイン',
  'アチャモ',
  'ワカシャモ',
  'バシャーモ',
  'ミズゴロウ',
  'ヌマクロー',
  'ラグラージ',
  'ポチエナ',
  'グラエナ',
  'ジグザグマ',
  'マッスグマ',
  'ケムッソ',
  'カラサリス',
  'アゲハント',
  'マユルド',
  'ドコケイル',
  'ハスボー',
  'ハスブレロ',
  'ルンパッパ',
  'タネボー',
  'コノハナ',
  'ダーテング',
  'スバメ',
  'オオスバメ',
  'キャモメ',
  'ペリッパー',
  'ラルトス',
  'キルリア',
  'サーナイト',
  'アメタマ',
  'アメモース',
  'キノココ',
  'キノガッサ',
  'ナマケロ',
  'ヤルキモノ',
  'ケッキング',
  'ツチニン',
  'テッカニン',
  'ヌケニン',
  'ゴニョニョ',
  'ドゴーム',
  'バクオング',
  'マクノシタ',
  'ハリテヤマ',
  'ルリリ',
  'ノズパス',
  'エネコ',
  'エネコロロ',
  'ヤミラミ',
  'クチート',
  'ココドラ',
  'コドラ',
  'ボスゴドラ',
  'アサナン',
  'チャーレム',
  'ラクライ',
  'ライボルト',
  'プラスル',
  'マイナン',
  'バルビート',
  'イルミーゼ',
  'ロゼリア',
  'ゴクリン',
  'マルノーム',
  'キバニア',
  'サメハダー',
  'ホエルコ',
  'ホエルオー',
  'ドンメル',
  'バクーダ',
  'コータス',
  'バネブー',
  'ブーピッグ',
  'パッチール',
  'ナックラー',
  'ビブラーバ',
  'フライゴン',
  'サボネア',
  'ノクタス',
  'チルット',
  'チルタリス',
  'ザングース',
  'ハブネーク',
  'ルナトーン',
  'ソルロック',
  'ドジョッチ',
  'ナマズン',
  'ヘイガニ',
  'シザリガー',
  'ヤジロン',
  'ネンドール',
  'リリーラ',
  'ユレイドル',
  'アノプス',
  'アーマルド',
  'ヒンバス',
  'ミロカロス',
  'ポワルン',
  'カクレオン',
  'カゲボウズ',
  'ジュペッタ',
  'ヨマワル',
  'サマヨール',
  'トロピウス',
  'チリーン',
  'アブソル',
  'ソーナノ',
  'ユキワラシ',
  'オニゴーリ',
  'タマザラシ',
  'トドグラー',
  'トドゼルガ',
  'パールル',
  'ハンテール',
  'サクラビス',
  'ジーランス',
  'ラブカス',
  'タツベイ',
  'コモルー',
  'ボーマンダ',
  'ダンバル',
  'メタング',
  'メタグロス',
  'レジロック',
  'レジアイス',
  'レジスチル',
  'ラティアス',
  'ラティオス',
  'カイオーガ',
  'グラードン',
  'レックウザ',
  'ジラーチ',
  'デオキシス',
  'ナエトル',
  'ハヤシガメ',
  'ドダイトス',
  'ヒコザル',
  'モウカザル',
  'ゴウカザル',
  'ポッチャマ',
  'ポッタイシ',
  'エンペルト',
  'ムックル',
  'ムクバード',
  'ムクホーク',
  'ビッパ',
  'ビーダル',
  'コロボーシ',
  'コロトック',
  'コリンク',
  'ルクシオ',
  'レントラー',
  'スボミー',
  'ロズレイド',
  'ズガイドス',
  'ラムパルド',
  'タテトプス',
  'トリデプス',
  'ミノムッチ',
  'ミノマダム',
  'ガーメイル',
  'ミツハニー',
  'ビークイン',
  'パチリス',
  'ブイゼル',
  'フローゼル',
  'チェリンボ',
  'チェリム',
  'カラナクシ',
  'トリトドン',
  'エテボース',
  'フワンテ',
  'フワライド',
  'ミミロル',
  'ミミロップ',
  'ムウマージ',
  'ドンカラス',
  'ニャルマー',
  'ブニャット',
  'リーシャン',
  'スカンプー',
  'スカタンク',
  'ドーミラー',
  'ドータクン',
  'ウソハチ',
  'マネネ',
  'ピンプク',
  'ペラップ',
  'ミカルゲ',
  'フカマル',
  'ガバイト',
  'ガブリアス',
  'ゴンベ',
  'リオル',
  'ルカリオ',
  'ヒポポタス',
  'カバルドン',
  'スコルピ',
  'ドラピオン',
  'グレッグル',
  'ドクロッグ',
  'マスキッパ',
  'ケイコウオ',
  'ネオラント',
  'タマンタ',
  'ユキカブリ',
  'ユキノオー',
  'マニューラ',
  'ジバコイル',
  'ベロベルト',
  'ドサイドン',
  'モジャンボ',
  'エレキブル',
  'ブーバーン',
  'トゲキッス',
  'メガヤンマ',
  'リーフィア',
  'グレイシア',
  'グライオン',
  'マンムー',
  'ポリゴンZ',
  'エルレイド',
  'ダインーズ',
  'ヨノワール',
  'ユキメノコ',
  'ロトム',
  'ユクシー',
  'エムリット',
  'アグノム',
  'ディアルガ',
  'パルキア',
  'ヒードラン',
  'レジギガス',
  'ギラティナ',
  'クレセリア',
  'フィオネ',
  'マナフィ',
  'ダークライ',
  'シェイミ',
  'アルセウス',
  'ビクティニ',
  'ツタージャ',
  'ジャノビー',
  'ジャローダ',
  'ポカブ',
  'チャオブー',
  'エンブオー',
  'ミジュマル',
  'フタチマル',
  'ダイケンキ',
  'ミネズミ',
  'ミルホッグ',
  'ヨーテリー',
  'ハーデリア',
  'ムーランド',
  'チョロネコ',
  'レパルダス',
  'ヤナップ',
  'ヤナッキー',
  'バオップ',
  'バオッキー',
  'ヒヤップ',
  'ヒヤッキー',
  'ムンア',
  'ムシャーナ',
  'マメパト',
  'ハトーボー',
  'ケンホロウ',
  'シママ',
  'ゼブライカ',
  'ダンゴロ',
  'ガントル',
  'ギガイアス',
  'コロモリ',
  'ココロモリ',
  'モグリュー',
  'ドリュウズ',
  'タブンネ',
  'ドッコラー',
  'ドテッコツ',
  'ローブシン',
  'オタマロ',
  'ガマガル',
  'ガマゲロゲ',
  'ナゲキ',
  'ダゲキ',
  'クルミル',
  'クルマユ',
  'ハハコモリ',
  'フシデ',
  'ホイーガ',
  'ペンドラー',
  'モンメン',
  'エルフーン',
  'チュリネ',
  'ドレディア',
  'バスラオ',
  'メグロコ',
  'ワルビル',
  'ワルビアル',
  'ダルマッカ',
  'ヒヒダルマ',
  'マラカッチ',
  'イシズマイ',
  'イワパレス',
  'ズルッグ',
  'ズルズキン',
  'シンボラー',
  'デスマス',
  'デスカーン',
  'プロトーガ',
  'アバゴーラ',
  'アーケン',
  'アーケオス',
  'ヤブクロン',
  'ダストダス',
  'ゾロア',
  'ゾロアーク',
  'チラーミィ',
  'チラチーノ',
  'ゴチム',
  'ゴチミル',
  'ゴチルゼル',
  'ユニラン',
  'ダブラン',
  'ランクルス',
  'コアルヒー',
  'スワンナ',
  'バニプッチ',
  'バニリッチ',
  'バイバニラ',
  'シキジカ',
  'メブキジカ',
  'エモンガ',
  'カブルモ',
  'シュバルゴ',
  'タマゲタケ',
  'モロバレル',
  'ブルリル',
  'ブルンゲル',
  'ママンボウ',
  'バチュル',
  'デンチュラ',
  'テッシード',
  'ナットレイ',
  'ギアル',
  'ギギアル',
  'ギギギアル',
  'シビシラス',
  'シビビール',
  'シビルドン',
  'リグレー',
  'オーベム',
  'ヒトモシ',
  'ランプラー',
  'シャンデラ',
  'キバゴ',
  'オノンド',
  'オノノクス',
  'クマシュン',
  'ツンベアー',
  'フリージオ',
  'チョボマキ',
  'アギルダー',
  'マッギョ',
  'コジョフー',
  'コジョンド',
  'クリムガン',
  'ゴビット',
  'ゴルーグ',
  'コマタナ',
  'キリキザン',
  'バッフロン',
  'ワシボン',
  'ウォーグル',
  'バルチャイ',
  'バルジーナ',
  'クイタラン',
  'アイアント',
  'モノズ',
  'ジヘッド',
  'サザンドラ',
  'メラルバ',
  'ウルガモス',
  'コバルオン',
  'テラキオン',
  'ビリジオン',
  'トルネロス',
  'ボルトロス',
  'レシラム',
  'ゼクロム',
  'ランドロス',
  'キュレム',
  'ケルディオ',
  'メロエッタ',
  'ゲノセクト',
  'ハリマロン',
  'ハリボーグ',
  'ブリガロン',
  'フォッコ',
  'テールナー',
  'マフォクシー',
  'ケロマツ',
  'ゲコガシラ',
  'ゲッコウガ',
  'ホルビー',
  'ホルード',
  'ヤヤコマ',
  'ヒノヤコマ',
  'ファイアロー',
  'コフキムシ',
  'コフーライ',
  'ビビヨン',
  'シシコ',
  'カエンジシ',
  'フラベベ',
  'フラエッテ',
  'フラージェス',
  'メェークル',
  'ゴーゴート',
  'ヤンチャム',
  'ゴロンダ',
  'トリミアン',
  'ニャスパー',
  'ニャオニクス',
  'ヒトツキ',
  'ニダンギル',
  'ギルガルド',
  'シュシュプ',
  'フレフワン',
  'ペロッパフ',
  'ペロリーム',
  'マーイーカ',
  'カラマネロ',
  'カメテテ',
  'ガメノデス',
  'クズモー',
  'ドラミドロ',
  'ウデッポウ',
  'ブロスター',
  'エリキテル',
  'エレザード',
  'チゴラス',
  'ガチゴラス',
  'アマルス',
  'アマルルガ',
  'ニンフィア',
  'ルチャブル',
  'デデンネ',
  'メレシー',
  'ヌメラ',
  'ヌメイル',
  'ヌメルゴン',
  'クレッフィ',
  'ボクレー',
  'オーロット',
  'バケッチャ',
  'パンプジン',
  'カチコール',
  'クレベース',
  'オンバット',
  'オンバーン',
  'ゼルネアス',
  'イベルタル',
  'ジガルデ',
  'ディアンシー',
  'フーパ',
  'ボルケニオン',
  'モクロー',
  'フクスロー',
  'ジュナイパー',
  'ニャビー',
  'ニャヒート',
  'ガオガエン',
  'アシマリ',
  'オシャマリ',
  'アシレーヌ',
  'ツツケラ',
  'ケララッパ',
  'ドデカバシ',
  'ヤングース',
  'デカグース',
  'アゴジムシ',
  'デンジムシ',
  'クワガノン',
  'マケンカニ',
  'ケケンカニ',
  'オドリドリ',
  'アブリー',
  'アブリボン',
  'イワンコ',
  'ルガルガン',
  'ヨワシ',
  'ヒドイデ',
  'ドヒドイデ',
  'ドロバンコ',
  'バンバドロ',
  'シズクモ',
  'オニシズクモ',
  'カリキリ',
  'ラランテス',
  'ネマシュ',
  'マシェード',
  'ヤトウモリ',
  'エンニュート',
  'ヌイコグマ',
  'キテルグマ',
  'アマカジ',
  'アママイコ',
  'アマージョ',
  'キュワワー',
  'ヤレユータン',
  'ナゲツケサル',
  'コソクムシ',
  'グソクムシャ',
  'スナバァ',
  'シロデスナ',
  'ナマコブシ',
  'タイプ：ヌル',
  'シルヴァディ',
  'メテノ',
  'ネッコアラ',
  'バクガメス',
  'トゲデマル',
  'ミミッキュ',
  'ハギギシリ',
  'ジジーロン',
  'ダダリン',
  'ジャラコ',
  'ジャランゴ',
  'ジャラランガ',
  'カプ・コケコ',
  'カプ・テテフ',
  'カプ・ブルル',
  'カプ・レヒレ',
  'コスモッグ',
  'コスモウム',
  'ソルガレオ',
  'ルナアーラ',
  'ウツロイド',
  'マッシブーン',
  'フェローチェ',
  'デンジュモク',
  'テッカグヤ',
  'カミツルギ',
  'アクジキング',
  'ネクロズマ',
  'マギアナ',
  'マーシャドー',
  'ベベノム',
  'アーゴヨン',
  'ツンデツンデ',
  'ズガドーン',
  'ゼラオラ',
  'メルタン',
  'メルメタル',
  'サルノリ',
  'バチンキー',
  'ゴリランダー',
  'ヒバニー',
  'ラビフット',
  'エースバーン',
  'メッソン',
  'ジメレオン',
  'インテレオン',
  'ホシガリス',
  'ヨクバリス',
  'ココガラ',
  'アオガラス',
  'アーマーガア',
  'サッチムシ',
  'レドームシ',
  'イオルブ',
  'クスネ',
  'フォクスライ',
  'ヒメンカ',
  'ワタシラガ',
  'ウールー',
  'バイウールー',
  'カムカメ',
  'カジリガメ',
  'ワンパチ',
  'パルスワン',
  'タンドン',
  'トロッゴン',
  'セキタンザン',
  'カジッチュ',
  'アップリュー',
  'タルップル',
  'スナヘビ',
  'サダイジャ',
  'ウッウ',
  'サシカマス',
  'カマスジョー',
  'エレズン',
  'ストリンダー',
  'ヤクデ',
  'マルヤクデ',
  'タタッコ',
  'オトスパス',
  'ヤバチャ',
  'ポットデス',
  'ミブリム',
  'テブリム',
  'ブリムオン',
  'ベロバー',
  'ギモー',
  'オーロンゲ',
  'タチフサグマ',
  'ニャイキング',
  'サニゴーン',
  'ネギガナイト',
  'バリコオル',
  'デスバーン',
  'マホミル',
  'マホイップ',
  'タイレーツ',
  'バチンウニ',
  'ユキハミ',
  'モスノウ',
  'イシヘンジン',
  'コオリッポ',
  'イエッサン',
  'モルペコ',
  'ゾウドウ',
  'ダイオウドウ',
  'パッチラゴン',
  'パッチルドン',
  'ウオノラゴン',
  'ウオチルドン',
  'ジュラルドン',
  'ドラメシヤ',
  'ドロンチ',
  'ドラパルト',
  'ザシアン',
  'ザマゼンタ',
  'ムゲンダイナ',
  'ダクマ',
  'ウーラオス',
  'ザルード',
  'レジエレキ',
  'レジドラゴ',
  'ブリザポス',
  'レイスポス',
  'バドレックス',
  'アヤシシ',
  'バサギリ',
  'ガチグマ',
  'イダイトウ',
  'オオニューラ',
  'ハリーマン',
  'ラブトロス',
  'ニャオハ',
  'ニャローテ',
  'マスカーニャ',
  'ホゲータ',
  'アチゲータ',
  'ラウドボーン',
  'クワッス',
  'ウェルカモ',
  'ウェーニバル',
  'グルトン',
  'パフュートン',
  'ノココッチ',
  'タマンチュラ',
  'ワナイダー',
  'マメバッタ',
  'エクスレッグ',
  'シガロコ',
  'ベラカス',
  'ボチ',
  'ハカドッグ',
  'ヒラヒナ',
  'クエスパトラ',
  'リキキリン',
  'ウミディグダ',
  'ウミトリオ',
  'ヘイラッシャ',
  'ミガルーサ',
  'ナミイルカ',
  'イルカマン',
  'ミニーブ',
  'オリーニョ',
  'オリーヴァ',
  'カプサイジ',
  'スコヴィラン',
  'ズピカ',
  'ハラバリー',
  'ブロロン',
  'ブロロローム',
  'ミミズズ',
  'ワッカネズミ',
  'イッカネズミ',
  'アルクジラ',
  'ハルクジラ',
  'セビエ',
  'セゴール',
  'セグレイブ',
  'シャリタツ',
  'モトトカゲ',
  'パモ',
  'パモット',
  'パーモット',
  'カイデン',
  'タイカイデン',
  'オトシドリ',
  'イキリンコ',
  'カラミンゴ',
  'ガケガニ',
  'コジオ',
  'ジオヅム',
  'キョジオーン',
  'キラーメ',
  'キラフロル',
  'シルシュルー',
  'タギングル',
  'パピモッチ',
  'バウッツェル',
  'オラチフ',
  'マフィティフ',
  'アノクサ',
  'アノホラグサ',
  'コレクレー',
  'サーフゴー',
  'イダイナキバ',
  'アラブルタケ',
  'スナノケガワ',
  'サケブシッポ',
  'ハバタクカミ',
  'チヲハウハネ',
  'トドロクツキ',
  'テツノワダチ',
  'テツノドクガ',
  'テツノカイナ',
  'テツノコウベ',
  'テツノイバラ',
  'テツノツツミ',
  'テツノブジン',
  'ディンルー',
  'パオジアン',
  'チオンジェン',
  'イーユイ',
  'コライドン',
  'ミライドン',
  'カヌチャン',
  'ナカヌチャン',
  'デカヌチャン',
  'カルボウ',
  'グレンアルマ',
  'ソウブレイズ',
  'ノノクラゲ',
  'リククラゲ',
  'ドドゲザン',
  'ドオー',
  'コノヨザル'
];
